import React, {useEffect, useState} from 'react';
import ReceiverList from "./ReceiverList";
import {Col, Row} from "react-bootstrap";

const Receiver = ({
                    propReceiveList = undefined,
                    propUserList = undefined,
                    propOnChange = undefined
                  }) => {

  const [allList, setAllList] = useState([]);
  const [convertUnreceivedList, setConvertUnreceivedList] = useState([]);

  useEffect(() => {
    // console.log(propUserList);
    // console.log(propReceiveList);
    let temp = propUserList.filter((item) => propReceiveList.some((i) => i === item.cd));
    // console.log(temp);

    temp.map((item) => {
      setConvertUnreceivedList((prevState => [...prevState, {id: item.cd, name: item.nm, isSelected: true}]));
    });
  }, [propReceiveList]);

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    propUserList.map((item) => {
      // console.log(item);
      setAllList(prevArray => [...prevArray, {id: item.cd, name: item.nm, isSelected: false}]); // AllList 형변환
    });

    // console.log(propReceiveList);
    /*    let temp = propUserList.filter((item) => propReceiveList.some((i) => i === item.cd));
        console.log(temp);

        temp.map((item) => {
          setConvertUnreceivedList((prevState => [...prevState, {id: item.cd, name: item.nm, isSelected: true}]));
        });*/
  }, [propUserList]);

  useEffect(() => {
    let items = [];
    // eslint-disable-next-line array-callback-return
    allList.map((item, idx) => {
      if (item.isSelected) {
        items.push(item.id);
      }
    });
    console.log(items);
    propOnChange(items);
  }, [allList]);


  useEffect(() => {
    if (allList.length !== 0) {
      const falseResult = allList.filter(item => {
        return !convertUnreceivedList.some(other => other.id === item.id);
      });

      const trueResult = convertUnreceivedList.filter(item => {
        return allList.some(other => other.id === item.id);
      });

      setAllList(falseResult.concat(trueResult));
    }
  }, [convertUnreceivedList]);


  return (
      <Row>
        <Col md={12}>
          <ReceiverList
              propList={allList}
              propSetList={setAllList}
          />
        </Col>
      </Row>
  );
};

export default Receiver;
